// TelcoTrack — jméno člověka, který nedodělek otevřel.

/**
 * Zobrazované jméno pro řádek „Otevřel“.
 * Uložené jméno má přednost. Záložní jméno z adresáře jen když uložené chybí.
 * Prázdné jméno je pomlčka. E-mail se nezobrazuje.
 */
export function nedodelekOpenedByLabel(
  storedName: string | null | undefined,
  directoryName?: string | null,
): string {
  const stored = typeof storedName === 'string' ? storedName.trim() : '';
  if (stored) return stored;
  const directory = typeof directoryName === 'string' ? directoryName.trim() : '';
  return directory || '—';
}
